const religionColors = {
  RELIGION_50: '#EDE7F8',
  RELIGION_100: '#D1C4ED',
  RELIGION_200: '#B29DE3',
  RELIGION_600: '#5834C0',
}

export default religionColors
